import { ROW_KIND } from "./orderOfGo";

// "2h 5m" / "5m" — coarse on purpose; this is "how long until the next
// event", not a race-clock stopwatch.
export function formatCountdown(ms) {
  if (ms <= 0) return "0m";
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
}

// The next event's own label — a break announces its label (or the generic
// "Break"), a ride announces its class number + rider, matching the fields
// already shown on its row.
export function nextEventLabel(row, t) {
  if (!row) return "";
  if (row.kind === ROW_KIND.BREAK) return row.label || t("oog.breakLabel");
  return [row.classNumber, row.riderName].filter(Boolean).join(" — ");
}
